import { BASE_PATH as CARD_PATH } from './forthbridge-cards';
import { BASE_PATH as COMMUNICATION_PATH } from './communication';
import { BASE_PATH as FORTHBRIDGE_APPOINTMENT_PATH } from './forthbridge-appointment';
import { BASE_PATH as FORTHBRIDGE_RECOMMENDATION_PATH } from './forthbridge-recommendation';
import { BASE_PATH as CONSENT_PATH } from './consent';
import { BASE_PATH as SUPERTOKENS_PATH } from './supertokens';
import { BASE_PATH as FORMS_PATH } from './forms';
import { BASE_PATH as WORKFLOW_PATH } from './workflow';
import { BASE_PATH as ORGANIZATION_PATH } from './organization';
import { BASE_PATH as LANGUAGES_PATH } from './languages';
import { BASE_PATH as PATIENT_PATH } from './patient';
import { BASE_PATH as FORTHBRIDGE_WAITING_ROOM_PATH } from './forthbridge-waiting-room';
import { BASE_PATH as FORTHBRIDGE_MEDICATION } from './forthbridge-medication';
import { BASE_PATH as PROGRAM_PATH } from './program';
import { BASE_PATH as ORDER_PATH } from './order';
import { BASE_PATH as FORTHBRIDGE_CARE_PLAN } from './forthbridge-care-plan';
import { BASE_PATH as FORTHBRIDGE_CLINICAL_DOCUMENT } from './forthbridge-clinical-document';
import { BASE_PATH as FORTHBRIDGE_WORK_MANAGEMENT } from './forthbridge-work-management';
import { BASE_PATH as FORTHBRIDGE_OBSERVATIONS } from './forthbridge-observations';
import { BASE_PATH as DOCUMENTS_PATH } from './documents';
import { BASE_PATH as WORKFLOW_EXECUTION_PATH } from './workflow-execution';
import { BASE_PATH as FORTHBRIDGE_APP_CONFIGURATION } from './forthbridge-app-configuration';
import { BASE_PATH as FORTHBRIDGE_ALLERGY } from './forthbridge-allergy';
import { BASE_PATH as FORTHBRIDGE_IMMUNIZATION } from './forthbridge-immunization';
import { BASE_PATH as FORTHBRIDGE_DIAGNOSIS } from './forthbridge-diagnosis';
import { BASE_PATH as PAYMENTS_PATH } from './payments';
import { BASE_PATH as EXTERNAL_INTEGRATIONS } from './external-integrations';

export const SWAGGER_BASE_PATHS = [
  CARD_PATH,
  EXTERNAL_INTEGRATIONS,
  SUPERTOKENS_PATH,
  COMMUNICATION_PATH,
  CONSENT_PATH,
  ORGANIZATION_PATH,
  LANGUAGES_PATH,
  PATIENT_PATH,
  FORMS_PATH,
  WORKFLOW_PATH,
  FORTHBRIDGE_WAITING_ROOM_PATH,
  FORTHBRIDGE_APPOINTMENT_PATH,
  FORTHBRIDGE_RECOMMENDATION_PATH,
  FORTHBRIDGE_MEDICATION,
  PROGRAM_PATH,
  ORDER_PATH,
  DOCUMENTS_PATH,
  FORTHBRIDGE_CARE_PLAN,
  FORTHBRIDGE_CLINICAL_DOCUMENT,
  FORTHBRIDGE_WORK_MANAGEMENT,
  PAYMENTS_PATH,
  FORTHBRIDGE_OBSERVATIONS,
  WORKFLOW_EXECUTION_PATH,
  FORTHBRIDGE_APP_CONFIGURATION,
  FORTHBRIDGE_ALLERGY,
  FORTHBRIDGE_IMMUNIZATION,
  FORTHBRIDGE_DIAGNOSIS,
];
